import { render, staticRenderFns } from "./SelectImageChooser.vue?vue&type=template&id=512e607f&scoped=true"
import script from "./SelectImageChooser.vue?vue&type=script&lang=js"
export * from "./SelectImageChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512e607f",
  null
  
)

export default component.exports